const Services = [
    
    {
        ID: 1,
        Name: 'Derecho Penal',
        Image: require('../Assets/images/Servicios/Derecho-Penal.avif'),
        content:`
                    Contamos con expertos en la defensa de derechos y en la representación en todas las etapas del proceso penal, ya sea como víctima o imputado.
                    <br/>
                    <br/>
                    Nuestros servicios incluyen:
                    <br/>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Defensa Penal Estratégica: Protección y asesoramiento personalizado para garantizar tus derechos.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Asistencia a Víctimas: Representación legal para que obtengas justicia y reparación.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Delitos Complejos: Especialización en delitos y causas de alta relevancia.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Consultas Preventivas: Orientación jurídica para evitar riesgos legales.</span>
                    <br/>
                    Nos enfocamos en brindarte soluciones efectivas con profesionalismo, confidencialidad y compromiso, porque sabemos que cada caso es único y merece una estrategia personalizada.
                `
    },

    {
        ID: 2,
        Name: 'Derecho de Familia',
        Image: require('../Assets/images/Servicios/Derecho-de-Familia.avif'),
        content:`
                    Ofrecemos un acompañamiento profesional y empático en los momentos más importantes y sensibles de tu vida. Nos especializamos en resolver conflictos familiares y brindar soluciones legales personalizadas, siempre priorizando tus derechos y los de tus seres queridos.
                    <br/>
                    <br/>
                    Nuestros servicios incluyen:
                    <br/>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Asesoramiento en divorcios: Gestión integral de acuerdos, división de bienes y compensaciones económicas.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Alimentos y cuidado de hijos: Garantizamos la protección de los derechos de los menores y su bienestar económico.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Responsabilidad parental y régimen de visitas: Soluciones justas para asegurar el equilibrio familiar.</span>
                    <br/>
                    Nos comprometemos a brindarte soluciones rápidas, efectivas y humanas, porque entendemos la importancia de tu bienestar y el de tu familia.
                `
    },

    {
        ID: 3,
        Name: 'Derecho Civil',
        Image: require('../Assets/images/Servicios/Derecho-Civil.avif'),
        content:`
                    Recibí asesoramiento legal completo y personalizado en todos los aspectos del derecho civil. Sabemos que cada situación es única, y nuestro objetivo es proteger tus derechos y resolver tus conflictos con soluciones efectivas.
                    <br/>
                    <br/>
                    Nuestros servicios incluyen:
                    <br/>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Accidentes y responsabilidad civil: Gestión integral de indemnizaciones por daños en accidentes de tránsito, laborales o de cualquier índole.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Contratos y obligaciones: Redacción, revisión y resolución de conflictos contractuales con seguridad jurídica.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Propiedad y bienes: Asesoramiento en compraventa, derechos reales, hipotecas y otros trámites patrimoniales.</span>
                    <br/>
                    Te brindamos un acompañamiento legal confiable, enfocado en resguardar tus intereses y encontrar soluciones rápidas y justas. 
                `
    },

    {
        ID: 4,
        Name: 'Derecho Comercial',
        Image: require('../Assets/images/Servicios/Derecho-Comercial.avif'),
        content:`
                    Protegé e impulsá tu negocio y tus intereses en cada etapa de tus operaciones comerciales con el asesoramiento correcto.
                    <br/>
                    <br/>
                    Nuestros servicios incluyen:
                    <br/>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Constitución y gestión de sociedades: Asesoramiento en la creación, transformación y disolución de empresas, y en la redacción de contratos societarios.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Contratos comerciales: Redacción, análisis y resolución de conflictos en acuerdos como compraventas, franquicias y leasing.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Insolvencias y concursos: Gestión estratégica en casos de reestructuración de deudas, concursos preventivos y quiebras.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Propiedad industrial: Registro y protección de marcas, patentes y diseños industriales para resguardar tu innovación.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Defensa del consumidor y competencia leal: Representación y estrategias para cumplir con las normativas de mercado y proteger tu reputación empresarial.</span>
                    <br/>
                    Con un enfoque en la eficiencia, la legalidad y la estrategia comercial, te ayudamos a alcanzar tus objetivos con seguridad y confianza. 
                `
    },

    {
        ID: 5,
        Name: 'Derecho Laboral',
        Image: require('../Assets/images/Servicios/Derecho-Laboral.avif'),
        content:`
                    Brindamos un asesoramiento laboral integral, defendiendo tus derechos y ofreciendo soluciones estratégicas para resolver conflictos en el ámbito del trabajo.
                    <br/>
                    <br/>
                    Nuestros servicios incluyen:
                    <br/>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Reclamos laborales: Asesoramiento y representación en casos de despidos, indemnizaciones, salarios adeudados y condiciones laborales injustas.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Conflictos individuales y colectivos: Negociación y resolución de disputas entre empleados y empleadores o entre sindicatos y empresas.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Accidentes y ART: Representación en casos de accidentes laborales y enfermedades profesionales, desde accidentes súbitos y violentos ocurridos en el lugar de trabajo, hasta reclamos por falta de cobertura adecuada de la Aseguradora de Riesgos del Trabajo (ART). La cobertura de la ART se activa desde el momento del alta laboral, sin importar la antigüedad en el puesto, por lo que debe cubrir al empleado incluso durante el período de prueba.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Prevención y asesoramiento a empresas: Diseño de estrategias legales para garantizar el cumplimiento normativo y prevenir conflictos laborales.</span>
                    <br/>
                    Te ofrecemos un enfoque profesional, confidencial y eficaz, orientado a proteger tus intereses en cada situación. 
                `
    },

    {
        ID: 6,
        Name: 'Derecho Administrativo',
        Image: require('../Assets/images/Servicios/Derecho-Administrativo.avif'),
        content:`
                    Ofrecemos un asesoramiento experto y estratégico en derecho administrativo, brindándote el respaldo legal necesario para interactuar con la Administración Pública de manera efectiva y proteger tus derechos frente al Estado.
                    <br/>
                    <br/>
                    Nuestros servicios incluyen:
                    <br/>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Impugnación de actos administrativos: Defensa ante resoluciones arbitrarias o ilegales emitidas por organismos públicos.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Contrataciones y licitaciones públicas: Asesoramiento en la participación, adjudicación y cumplimiento de contratos con la Administración Pública.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Responsabilidad del Estado: Representación en reclamos por daños ocasionados por el accionar del Estado, ya sea lícito o ilícito.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Gestión de trámites y permisos: Asistencia en procedimientos administrativos, obtención de habilitaciones, licencias y autorizaciones.</span>
                    <br/>
                    <span style="display: block; padding-left: 20px;">⦁ Defensa de empleados públicos: Representación en conflictos laborales y disciplinarios dentro del ámbito público.</span>
                    <br/>
                    Con un enfoque profesional y comprometido, trabajamos para garantizar que tu relación con la Administración Pública sea transparente y equitativa. 
                `
    },

    {
        ID: 7,
        Name: 'Sucesiones',
        Image: require('../Assets/images/Servicios/Sucesiones.avif'),
        content:`
                    Te acompañamos en cada paso del proceso sucesorio, brindando un asesoramiento profesional y humano para resolver la distribución del patrimonio de manera rápida y efectiva.
                    <br/>
                    <br/>
                    Nuestros servicios incluyen:
                        <br/>
                        <br/>
                        <span style="display: block; padding-left: 20px;">⦁ Tramitación de sucesiones: Gestión integral de sucesiones testamentarias e intestadas.</span>
                        <br/>
                        <span style="display: block; padding-left: 20px;">⦁ División de bienes: Asesoramiento en la partición y distribución justa del patrimonio entre los herederos.</span>
                        <br/>
                        <span style="display: block; padding-left: 20px;">⦁ Conflictos hereditarios: Resolución de disputas entre herederos mediante estrategias legales y mediación.</span>
                        <br/>
                        <span style="display: block; padding-left: 20px;">⦁ Testamentos y planificación sucesoria: Diseño de estrategias para proteger y organizar tu patrimonio en vida.</span>
                        <br/>
                    Nuestro compromiso es brindarte tranquilidad, claridad y soluciones eficientes en momentos sensibles, garantizando que tus derechos y los de tu familia estén protegidos.
                `
    },
    
    {
        ID: 8,
        Name: 'Amparos',
        Image: require('../Assets/images/Servicios/Amparos.avif'),
        content: `
                    Te brindamos herramientas legales eficaces para proteger tus derechos fundamentales ante vulneraciones por parte de particulares, empresas o el Estado.
                    <br/>
                    <br/>
                    Nuestros servicios incluyen:
                        <br/>
                        <br/>
                        <span style="display: block; padding-left: 20px;">⦁ Amparo por derechos constitucionales: Presentación de acciones para garantizar derechos esenciales como la salud, educación, vivienda y libertad de expresión.</span>
                        <br/>
                        <span style="display: block; padding-left: 20px;">⦁ Amparos en salud: Reclamos ante obras sociales, prepagas o el sistema público para garantizar el acceso a tratamientos, medicamentos o prestaciones médicas negadas.</span>
                        <br/>
                        <span style="display: block; padding-left: 20px;">⦁ Amparo en educación: Representación en casos de acceso denegado o vulneración del derecho a la educación.</span>
                        <br/>
                        <span style="display: block; padding-left: 20px;">⦁ Amparo por mora administrativa: Acciones legales ante demoras injustificadas de la Administración Pública en resolver trámites o solicitudes.</span>
                        <br/>
                    Nuestro compromiso es actuar con urgencia y eficacia para que tus derechos sean protegidos y respetados.
                `
    }
    
]

export default Services;